import React from 'react';
import { Result, Button, Grid } from 'antd';
import { LockOutlined, HomeOutlined, ArrowLeftOutlined, LogoutOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { useLanguage } from 'hooks/Languages/useLanguage';
import useLogout from 'hooks/useLogout';
import { useFetchUserData } from 'queries/auth/user';
import { getDashboardPath } from 'utils/navigation';

const AccessDenied: React.FC = () => {
  const { translate } = useLanguage();
  const navigate = useNavigate();
  const { onHandleLogout, loadLogoutUser } = useLogout();
  const { userData } = useFetchUserData();
  const screens = Grid.useBreakpoint();
  const isMobile = !screens.md;

  return (
    <div style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      minHeight: '80vh',
      padding: isMobile ? '16px' : '24px',
      background: 'transparent'
    }}>
      <Result
        status="403"
        icon={<LockOutlined style={{ fontSize: isMobile ? '56px' : '72px', color: '#ff4d4f', filter: 'drop-shadow(0 4px 6px rgba(255, 77, 79, 0.2))' }} />}
        title={<span style={{ fontSize: isMobile ? '22px' : '28px', fontWeight: 700, color: '#1e293b' }}>{translate('Access Restricted')}</span>}
        subTitle={
          <div style={{ maxWidth: '500px', margin: '0 auto', color: '#64748b', fontSize: isMobile ? '14px' : '15px', lineHeight: '1.6', marginTop: '8px' }}>
            {translate('Your account does not have the permissions required to view this module. Please contact your system administrator if you believe this is an error.')}
          </div>
        }
        extra={
          <div 
            style={{ 
              display: 'flex', 
              flexDirection: isMobile ? 'column' : 'row', 
              gap: '12px', 
              justifyContent: 'center',
              alignItems: 'stretch',
              width: '100%',
              maxWidth: isMobile ? '280px' : 'none',
              margin: '16px auto 0'
            }}
          >
            <Button 
              onClick={() => navigate(-1)} 
              icon={<ArrowLeftOutlined />}
              size="large"
              block={isMobile}
              style={{ borderRadius: '10px' }}
            >
              {translate('Go Back')}
            </Button>
            <Button 
              type="primary" 
              onClick={() => navigate(getDashboardPath(userData))} 
              icon={<HomeOutlined />}
              size="large"
              block={isMobile}
              style={{ 
                background: 'var(--primary-color, #3b82f6)', 
                borderColor: 'var(--primary-color, #3b82f6)',
                borderRadius: '10px'
              }}
            >
              {translate('Go to Dashboard')}
            </Button>
            <Button 
              danger 
              onClick={onHandleLogout} 
              loading={loadLogoutUser}
              icon={<LogoutOutlined />}
              size="large"
              block={isMobile}
              style={{ borderRadius: '10px' }}
            >
              {translate('Logout')}
            </Button>
          </div>
        }
      />
    </div>
  );
};

export default AccessDenied;
